<template>
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 96 96"><path d="M92 16H4a2 2 0 0 0-2 2v59c0 1.1.9 2 2 2h88a2 2 0 0 0 2-2V18a2 2 0 0 0-2-2m-5.49 4L55.72 45.9a12 12 0 0 1-15.44 0L9.48 20zM90 72.95 63.22 52.4a2 2 0 0 0-2.44 3.18L86.1 75H9.9l25.32-19.41a2 2 0 1 0-2.44-3.18L6 72.95V22.29l31.7 26.66a16.1 16.1 0 0 0 20.6 0L90 22.3z"/></svg>
</template>
